import { defineStore } from 'pinia';
import { ShippingAddressType } from '~~/types/checkout/ShippingAddressType';
import type { ShippingAddressTypeState } from '~~/types/vuex/ShippingAddressType';

export const shippingAddressTypeStore = defineStore('shippingAddressType', {
  state: () => ({
    shippingAddressType: ShippingAddressType.SAME_AS_BILLING as ShippingAddressTypeState['shippingAddressType'] | null,
  }),
  actions: {
    setShippingAddressType(payload: ShippingAddressTypeState['shippingAddressType'] | null) {

      this.shippingAddressType = payload; 

    },
  },
});
